/**
 * Mehrfachauswahl von Apartments mit „Alle auswählen".
 */
import type { AvailabilityDistributionApartment } from '@/shared/api';

interface ApartmentChecklistProps {
  apartments: AvailabilityDistributionApartment[];
  selected: ReadonlySet<string>;
  disabled: boolean;
  onChange: (next: Set<string>) => void;
}

export function ApartmentChecklist({
  apartments,
  selected,
  disabled,
  onChange,
}: ApartmentChecklistProps) {
  const allSelected = apartments.length > 0 && selected.size === apartments.length;
  const toggle = (propertyId: string) => {
    const next = new Set(selected);
    if (next.has(propertyId)) next.delete(propertyId);
    else next.add(propertyId);
    onChange(next);
  };

  return (
    <div className="border-line/60 rounded-md border">
      <label className="border-line/50 text-ink flex min-h-11 cursor-pointer items-center gap-3 border-b px-3 text-[13px] font-semibold">
        <input
          type="checkbox"
          className="accent-sage size-5 cursor-pointer"
          checked={allSelected}
          disabled={disabled || apartments.length === 0}
          onChange={() =>
            onChange(allSelected ? new Set() : new Set(apartments.map((item) => item.propertyId)))
          }
        />
        Alle auswählen
        <span className="text-ink-faint ml-auto text-[12px] font-normal">
          {selected.size} von {apartments.length}
        </span>
      </label>
      <ul className="divide-line/40 max-h-72 divide-y overflow-y-auto">
        {apartments.map((apartment) => (
          <li key={apartment.propertyId}>
            <label className="text-ink hover:bg-paper/60 flex min-h-11 cursor-pointer items-center gap-3 px-3 text-[14px]">
              <input
                type="checkbox"
                className="accent-sage size-5 cursor-pointer"
                checked={selected.has(apartment.propertyId)}
                disabled={disabled}
                onChange={() => toggle(apartment.propertyId)}
              />
              {apartment.name}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}
